import cn from 'classnames'
import styles from './styles.module.css'
import ConferenceSchoolCheckbox from '../conference-school-checkbox'

const ConferenceSchoolCheckboxGroup = ({
    onUpdated,
    label,
    values,
    handleChange,
    className,
    labelClassName,
    tagsClassName,
    checkboxClassName,
    newsList
}) => {
    return <div className={cn(styles.checkboxGroup, className)}>
        {label && <div className={cn(styles.label, labelClassName)}>
            {label}
        </div>}

        <div className={cn(styles.checkboxGroupItems, tagsClassName)}>
            {values.map((item) => (item.map((item2) => {
                return <ConferenceSchoolCheckbox
                    key={item2.id}
                    id={item2.id}
                    value={item2.value}
                    name={item2.name}
                    color={item2.color}
                    onChange={handleChange}
                    className={checkboxClassName}
                    count={newsList.results?.filter((tag) => (tag.school_name===item2.id)).length}
                />
            })))}
        </div>
    </div>
}

export default ConferenceSchoolCheckboxGroup